"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const default_styles_1 = require("src/components/app/themes/default.styles");
const utils_1 = require("./utils");
function compilePadding(padding, prefix) {
    const [top, right = top, bottom = top, left = right] = padding.split(' ');
    const pfx = prefix ? `-${prefix}` : '';
    return {
        [`--page-padding${pfx}-top`]: top,
        [`--page-padding${pfx}-right`]: right,
        [`--page-padding${pfx}-bottom`]: bottom,
        [`--page-padding${pfx}-left`]: left
    };
}
// eslint-disable-next-line complexity
function compileUnderlayStyle(branding) {
    var _a, _b, _c, _d;
    const { underlay = {} } = branding;
    const bg = (_a = underlay === null || underlay === void 0 ? void 0 : underlay.bg) !== null && _a !== void 0 ? _a : default_styles_1.LIGHT_THEME_PAGE_BG_COLOR;
    let result = (0, utils_1.process)({
        'page-bg': bg,
        'page-gap': underlay === null || underlay === void 0 ? void 0 : underlay.gap,
        'page-height': underlay === null || underlay === void 0 ? void 0 : underlay.height,
        'page-safari-in-telegram-padding-bottom': (_b = underlay === null || underlay === void 0 ? void 0 : underlay.special) === null || _b === void 0 ? void 0 : _b.safariInTelegramPaddingBottom,
        'page-margin': underlay === null || underlay === void 0 ? void 0 : underlay.margin,
        'page-margin-mobile': (_c = underlay === null || underlay === void 0 ? void 0 : underlay.mobile) === null || _c === void 0 ? void 0 : _c.margin
    });
    if (underlay === null || underlay === void 0 ? void 0 : underlay.padding) {
        result = Object.assign(Object.assign({}, result), compilePadding(underlay.padding));
    }
    if ((_d = underlay === null || underlay === void 0 ? void 0 : underlay.mobile) === null || _d === void 0 ? void 0 : _d.padding) {
        result = Object.assign(Object.assign({}, result), compilePadding(underlay.mobile.padding, 'mobile'));
    }
    return result;
}
exports.default = compileUnderlayStyle;
